import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Row, Col, Space, Breadcrumb } from 'antd';
import { showSuccess, showError } from '../../../../components/errorHandler';
import { apiRequest } from '../../../../service/apiRequest';

const Settings: React.FC = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const response = await apiRequest({ method: 'get', url: '/setting' });
        console.log('Fetched sms settings:', response);
        if (response) {
          form.setFieldsValue(response);  // <-- This is correct
        }
      } catch (error) {
        showError('Failed to load sms settings');
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [form]);
  const handleSave = async (values: any) => {
    try {
      await apiRequest({
        method: 'put',
        url: '/save-settings', // ✅ your backend endpoint
        data: values,
      });
      showSuccess('settings saved successfully');
    } catch (error) {
      showError('Failed to save settings');
    }
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Settings' }]} />
      <Row gutter={16} justify="center">
        <Col span={12}>
          <Card title="Settings">
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSave}
              initialValues={{
                setting_logout_time: '',
                setting_mrp_code_value: '',
              }}
            >
              <Form.Item
                label="Logout Time (Minutes)"
                name="setting_logout_time"
              >
                <Input placeholder="Enter Logout Time In Minutes"
                type="number"
                  onInput={(e) => {
                    const input = e.currentTarget;
                    if (input.value.length > 4) {
                      input.value = input.value.slice(0, 4); // limit to max 3 digits
                    }
                  }}
                  min={0}
                  max={9999}
                />
              </Form.Item>

              <Form.Item
                label="MRP Code Value (Rs)"
                name="setting_mrp_code_value"
              >
                <Input placeholder="Enter MRP Code Value" 
                  type="number"
                  onInput={(e) => {
                    const input = e.currentTarget;
                    if (input.value.length > 5) {
                      input.value = input.value.slice(0, 5); // limit to max 5 digits
                    }
                  }}
                  min={0}
                  max={99999}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Save Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Space>
  );
};

export default Settings;
